import { useEffect, useState } from "react";
import axios from "axios";
import { brandStyle, logoUrl, themeOf, DEFAULT_THEME, SPOTTR_URL } from "@/lib/brand";
import { bizSlug } from "@/lib/api";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
pub.interceptors.request.use((cfg) => { const b = bizSlug(); const t = localStorage.getItem("ip_token"); if (t) cfg.headers.Authorization = `Bearer ${t}`; else if (b) cfg.params = { ...(cfg.params || {}), b }; return cfg; });

export const useBrand = () => {
  const [brand, setBrand] = useState(null);
  useEffect(() => { pub.get("/public/brand").then((r) => setBrand(r.data)).catch(() => setBrand({ theme: DEFAULT_THEME })); }, []);
  return brand;
};

export const brandName = (brand) => (brand ? brand.studioName || "Your Coach" : "\u00a0");

export const BrandLogo = ({ brand, size = 36, testId }) => {
  const url = logoUrl(brand?.logoKey);
  if (url) return <img src={url} alt={brandName(brand)} style={{ height: size, maxWidth: size * 3.5, objectFit: "contain", borderRadius: 8 }} data-testid={testId || "brand-logo"} />;
  return <div className="logo" style={{ width: size, height: size, background: "var(--accent)", color: "var(--on-accent)" }} data-testid={testId || "brand-logo"}>{brandName(brand).slice(0, 2).toUpperCase()}</div>;
};

export const Branded = ({ brand, children, className = "", style }) => (
  <div className={`branded ${className}`} style={{ ...brandStyle(brand), ...style }} data-theme={brand?.theme || DEFAULT_THEME} data-accent={brand?.accent || ""}>{children}</div>
);

export const SpottrMark = ({ size = 22, testId = "spottr-mark" }) => (
  <span className="spottr-mark" style={{ width: size, height: size }} data-testid={testId} aria-label="SpottrOS">
    <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62} fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><path d="M16.5 7.5c-1-1.2-2.6-1.8-4.5-1.8-2.7 0-4.5 1.3-4.5 3.1 0 4.2 9.3 1.9 9.3 6.6 0 2-2 3.3-4.8 3.3-2.1 0-3.9-.8-5-2.1" /></svg>
  </span>
);

export const PoweredBy = () => (
  <a className="powered" href={SPOTTR_URL} target="_blank" rel="noreferrer" data-testid="powered-by-spottr"><SpottrMark size={16} testId="powered-mark" />Powered by <b>SpottrOS</b></a>
);

export const brandTagline = (brand) => brand?.tagline || themeOf(brand?.theme).tagline;
